<template>
    <section class="p-0" id="coverage">
        <div id="coverage-header" class="masthead text-white text-center">
            <div class="container h-100 d-flex justify-content-center">
                <div class="my-auto">
                    <hr class="light" data-aos="fade-right">
                    <h1 class="text-white">
                    COBERTURA <br>
                    experiencia internacional
                    </h1>
                    <hr class="light" data-aos="fade-left">
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row text-center">
                <div class="col-xl-12 d-none d-lg-block">
                    <div class="col-xl-12 map-container">
                        <img class="img-fluid" src="/../img/Mapa_Internacional.png">
                        <h2 class="desktop-title-international">Cobertura<br> Internacional</h2>
                        <img class="desktop-img" src="/../img/maps/paises.png">
                        <hover-boxes :boxes="boxes" @close-box="closeBox" />
                        <div v-for="box in boxes" :key="box.id">
                            <div class="opener" @mouseover="mouseOver(box)" :class="box.class" :id="box.id"></div>
                        </div>
                    </div>
                </div>
                <div class="d-lg-none">
                    <div data-aos="fade-right" class="col-lg-9 col-md-12">
                        <img class="img-fluid" src="/../img/mapa.png">
                    </div>
                    <div data-aos="fade-left" class="col-lg-3 col-md-12">
                        <ul class="text-center">
                            <li class="parent"><p class="lead text-center">Estados Unidos</p></li>
                            <li class="parent"><p class="lead text-center">Panamá</p></li>
                            <li class="parent"><p class="lead text-center">Nicaragua</p></li>
                            <li class="parent"><p class="lead text-center">Perú</p></li>
                            <li class="parent"><p class="lead text-center">México</p></li>
                            <li class="parent"><p class="lead text-center">Rep. Dominicana</p></li>
                            <li class="parent"><p class="lead text-center">Guatemala</p></li>
                            <li class="parent"><p class="lead text-center">Honduras</p></li>
                            <li class="parent"><p class="lead text-center">Puerto Rico</p></li>
                            <li class="parent"><p class="lead text-center">El Salvador</p></li>
                            <li class="parent"><p class="lead text-center">Costa Rica</p></li>
                            <li class="parent"><p class="lead text-center">Colombia</p></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid p-0">
            <div class="row reddet text-center text-white p-2">
                <div class="col-lg-4 col-md-12">
                    <p style="margin-bottom: 0!important">
                        Especialistas en punto de compra <a target="_blank" href="https://www.visionymarketing.com.co"><br><img height="60" src="/../img/Logos_VyM.png"></a>
                    </p>
                </div>
                <div class="col-lg-4 col-md-12">
                    <p style="margin-bottom: 0!important">
                        Especialistas de shopper marketing a nivel LATAM
                        <a target="_blank" href=" http://redvolutionlatam.com"><br><img height="60" src="/../img/Logos_Redvolution.png"></a>
                    </p>
                </div>
                <div class="col-lg-4 col-md-12">
                    <p style="margin-bottom: 0!important">
                        Especialistas en crear experiencias memorables de consumo
                        <a target="_blank" href=" http://www.touch.cl"><br><img height="60" src="/../img/touch-blanco-01.png"></a>
                    </p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row text-center">
                <div class="col-xl-12 map-container">
                    <img class="img-fluid" src="/../img/maps/Mapa_Mexico.png">
                    <h2 class="desktop-title-national">Cobertura<br> Nacional</h2>
                    <img class="d-none d-lg-block desktop-img-offices" src="/../img/maps/oficinas.png">
                    <img class="d-none d-lg-block desktop-img-rooms" src="/../img/maps/salas.png">
                </div>
            </div>
        </div>
        <div class="col-md-12 text-center text-white p-2 reddet">
            <h3 class="text-white m-0">EMPRESAS DEL GRUPO</h3>
        </div>
        <div class="container-fluid p-0">
            <div class="row no-gutters">
                <div class="col-lg col-md-12 text-center text-white p-1">
                    <div class="container p-0 plecas">
                        <div class="row">
                            <div class="col-md-6 d-inline d-flex align-items-center">
                                <p class="text-dark lead text-center">Experiencias BTL</p>
                            </div>
                            <div class="col-md-6">
                                <a target="_blank" href="http://www.fanatic.lat">
                                    <img class="responsive mx-auto" src="/../img/fanatic.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg col-md-12 text-center text-white p-1">
                    <div class="container p-0 plecas">
                        <div class="row">
                            <div class="col-md-6 d-inline d-flex align-items-center">
                                <p class="text-dark lead text-center">Mobiliario y material PDV</p>
                            </div>
                            <div class="col-md-6">
                                <a target="_blank" href="https://area3d.mx/">
                                    <img class="responsive mx-auto" src="/../img/area3d.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg col-md-12 text-center text-white p-1">
                    <div class="container p-0 plecas">
                        <div class="row">
                            <div class="col-md-6 d-inline d-flex align-items-center">
                                <p class="text-dark lead text-center">Logística especializada en POP</p>
                            </div>
                            <div class="col-md-6">
                                <a target="_blank" href="http://www.361.com.mx/">
                                    <img class="responsive mx-auto" src="/../img/361.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg col-md-12 text-center text-white p-1">
                    <div class="container p-0 plecas">
                        <div class="row">
                            <div class="col-md-6 d-inline d-flex align-items-center">
                                <p class="text-dark lead text-center">Rappi</p>
                            </div>
                            <div class="col-md-6">
                                <a target="_blank" href="https://www.rappi.com">
                                    <img class="responsive mx-auto" src="/../img/rappi.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import HoverBoxes from './HoverBoxes.vue'
    import boxes from "./BoxesData.js";
    export default {
        name: 'Coverage',
        components: {
            HoverBoxes
        },
        data () {
            return {
                boxes: boxes.boxes,
            }
        },
        methods: {
            mouseOver (b) {
                this.boxes.forEach((item, index) => {
                    item.active = false
                })

                b.active = true
            },
            closeBox (box) {
                let item
                item = this.boxes.find((item) => {
                    return item.id == box.id
                })

                item.active = false
            }
        }
    }
</script>
<style scoped>
  #coverage-header {
  padding-top: 10rem;
  padding-bottom: calc(10rem - 56px);
  background-image: url("/../img/Fondo_Cobertura.png");
  background-position: center center;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.plecas {
    min-height: 120px;
    background: #ffffff; /* Old browsers */
    background: -moz-linear-gradient(left, #ffffff 0%, #f3f3f3 0%, #ffffff 57%, #ffffff 57%, #ededed 93%); /* FF3.6-15 */
    background: -webkit-linear-gradient(left, #ffffff 0%,#f3f3f3 0%,#ffffff 57%,#ffffff 57%,#ededed 93%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to right, #ffffff 0%,#f3f3f3 0%,#ffffff 57%,#ffffff 57%,#ededed 93%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ededed',GradientType=1 ); /* IE6-9 */
}

.plecas p {
    width: 100%;
    margin-bottom: 0;
}

.map-container {
    position: relative;
}

.desktop-title-international {
    position: absolute;
    top: 350px;
}

.desktop-title-national {
    display: block;
}

.desktop-img {
    position: absolute;
    top: 480px;
    left: 0px;
    height: 150px;
}

.desktop-img-offices {
    position: absolute;
    top: 310px;
    left: 0px;
    height: 150px;
}

.desktop-img-rooms {
    position: absolute;
    top: 480px;
    left: 50px;
    height: 150px;
}

.responsive {
    max-width: 100%;
    height: auto;
}

.opener {
    display: inline-block;
    position: absolute;
    cursor: pointer;
    border-radius: 50%;
    /* // background-color: #333; */
}


/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {

}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {

}

/* // Medium devices (tablets, 768px and up) */
@media (max-width: 768px) {

}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
    .desktop-title-national {
        position: absolute;
        top: 200px;
    }

    .map-container .estados {
        right: 294px;
        width: 35px;
        height: 35px;
        top: 128px;
    }

    .map-container .mexico {
        width: 35px;
        height: 35px;
        top: 254px;
        left: 339px;
    }

    .map-container .guatemala {
        width: 35px;
        height: 35px;
        top: 378px;
        left: 501px
    }

    .map-container .salvador {
        width: 20px;
        height: 20px;
        top: 407px;
        left: 540px;
    }

    .map-container .republica {
        width: 32px;
        height: 32px;
        top: 318px;
        right: 106px
    }

    .map-container .honduras {
        width: 35px;
        height: 35px;
        top: 372px;
        right: 326px;
    }

    .map-container .nicaragua {
        width: 35px;
        height: 35px;
        top: 415px;
        right: 312px;
    }

    .map-container .rica {
        width: 25px;
        height: 25px;
        top: 464px;
        right: 297px
    }

    .map-container .panama {
        width: 25px;
        height: 25px;
        top: 481px;
        right: 262px;
    }

    .map-container .colombia {
        width: 35px;
        height: 35px;
        top: 513px;
        right: 145px;
    }

    .map-container .peru {
        width: 30px;
        height: 30px;
        top: 712px;
        right: 178px;
    }

    .map-container .puerto {
        width: 25px;
        height: 25px;
        top: 336px;
        right: 37px
    }
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
    .map-container .estados {
        right: 348px;
        width: 45px;
        height: 45px;
        top: 153px;
    }

    .map-container .mexico {
        width: 45px;
        height: 45px;
        top: 303px;
        left: 403px;
    }

    .map-container .guatemala {
        width: 42px;
        height: 42px;
        top: 454px;
        left: 598px;
    }

    .map-container .salvador {
        width: 20px;
        height: 20px;
        top: 490px;
        left: 645px;
    }

    .map-container .republica {
        width: 40px;
        height: 40px;
        top: 384px;
        right: 123px;
    }

    .map-container .honduras {
        width: 42px;
        height: 42px;
        top: 445px;
        right: 389px;
    }

    .map-container .nicaragua {
        width: 45px;
        height: 45px;
        top: 497px;
        right: 371px;
    }

    .map-container .rica {
        width: 30px;
        height: 30px;
        top: 555px;
        right: 352px;
    }

    .map-container .panama {
        width: 30px;
        height: 30px;
        top: 577px;
        right: 311px;
    }

    .map-container .colombia {
        width: 40px;
        height: 40px;
        top: 619px;
        right: 174px;
    }

    .map-container .peru {
        width: 30px;
        height: 30px;
        top: 856px;
        right: 215px;
    }

    .map-container .puerto {
        width: 25px;
        height: 25px;
        top: 407px;
        right: 43px
    }
}
</style>


// WEBPACK FOOTER //
// src/components/coverage/Coverage.vue